import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Component, ElementRef, ViewChild, AfterViewInit, ComponentRef } from "@angular/core";
import { AgEditorComponent, AgRendererComponent } from "@bfx/ag-grid-angular";
import { BfxTextInputComponent } from "shared/base-components/bfx-text-input";

@Component({
  selector: "comment-editor",
  template: `<bfx-text-input
    #input
    [(ngModel)]="comment"
    [size]="'sm'"
    [maxLength]="255"
  ></bfx-text-input>`,
  standalone: false,
})
export class CommentEditor implements AgEditorComponent, AgRendererComponent {
  public params: any;
  public comment: string = "";

  @ViewChild("input", { static: true })
  public inputElement: BfxTextInputComponent;

  getValue(): any {
    let value: string = this.comment;

    if (this.params.context != null && this.params.context.setEditedValue != null) {
      this.params.context.setEditedValue(value, this.params);
    }

    return value;
  }

  // called on init
  agInit(params: any): void {
    this.params = params;
    this.comment = params.value;
  }

  public get editingEnabled(): boolean {
    if (this.params.context && this.params.context.isCellEditingEnabled) {
      return this.params.context.isCellEditingEnabled(this.params);
    }
    return false;
  }

  afterGuiAttached(): void {
    this.inputElement.focus();
  }

  isCancelBeforeStart?(): boolean {
    return !this.editingEnabled;
  }

  isCancelAfterEnd?(): boolean {
    return !this.editingEnabled;
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }

  /**********************************************************************/
  /* EVENT HANDLERS */

  public onFocus(event: any): void {
    if (event && event.target) {
      event.target.select();
    }
  }
}
